import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = () => {
  const location = useLocation();

  // The JWT is an httpOnly cookie (unreadable by JS), so we gate the UI on the
  // presence of the stored user object. Actual authorization is enforced by the
  // backend on every request; an expired cookie yields 401 → session cleared.
  const user = localStorage.getItem('user');

  if (!user) {
    return (
      <Navigate
        to="/signin"
        replace
        state={{ from: location }}
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
